var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasExtencion('vinoteca'))?_c('div',[_c('modal'),_c('delete-modal'),_c('b-button',{staticClass:"m-l-15",attrs:{"variant":"primary"},on:{"click":_vm.abrir_modal}},[_vm._v(" Promos ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }